var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.itemsPercentage),function(ref,index){
var height = ref.height;
var inRange = ref.inRange;
return _c('div',{key:(index + "_" + height),staticClass:"inline-block px-[0.2rem] w-[5%]",style:({
      height: (height + "%"),
    }),attrs:{"data-test":"graph-bar"}},[_c('div',{staticClass:"h-full rounded-1 w-full",class:{ 'bg-neutral-heavy': !inRange, 'bg-accent': inRange }})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }